import React, { useState } from 'react';

interface MarketDataTooltipProps {
  vaDataAsOf?: string | null;
  dodDataAsOf?: string | null;
}

/**
 * Info icon that shows a styled card tooltip with the latest available
 * market sales data month/year (VA and DOD) captured at bid creation.
 * Renders nothing when both values are null.
 */
export const MarketDataTooltip: React.FC<MarketDataTooltipProps> = ({
  vaDataAsOf,
  dodDataAsOf,
}) => {
  const [visible, setVisible] = useState(false);

  if (!vaDataAsOf && !dodDataAsOf) return null;

  return (
    <span
      style={{ position: 'relative', display: 'inline-flex', alignItems: 'center' }}
      onMouseEnter={() => setVisible(true)}
      onMouseLeave={() => setVisible(false)}
    >
      <i
        className="pi pi-info-circle"
        style={{ cursor: 'pointer', marginLeft: '8px', color: '#6366f1', fontSize: '1rem' }}
      />
      {visible && (
        <div
          style={{
            position: 'absolute',
            bottom: 'calc(100% + 10px)',
            left: '50%',
            transform: 'translateX(-50%)',
            background: '#ffffff',
            border: '1px solid #e2e8f0',
            borderRadius: '8px',
            boxShadow: '0 4px 16px rgba(0, 0, 0, 0.12)',
            padding: '10px 14px',
            whiteSpace: 'nowrap',
            zIndex: 9999,
            fontSize: '0.8rem',
            color: '#374151',
            lineHeight: '1.5',
            minWidth: '160px',
          }}
        >
          <div
            style={{
              fontWeight: 600,
              marginBottom: '6px',
              color: '#1e293b',
              borderBottom: '1px solid #f1f5f9',
              paddingBottom: '5px',
              fontSize: '0.78rem',
              letterSpacing: '0.03em',
              textTransform: 'uppercase',
            }}
          >
            Market Data As Of
          </div>
          {vaDataAsOf && (
            <div
              style={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                gap: '20px',
                padding: '2px 0',
              }}
            >
              <span style={{ color: '#64748b', fontSize: '0.78rem' }}>VA</span>
              <span style={{ fontWeight: 600, color: '#1e293b' }}>{vaDataAsOf}</span>
            </div>
          )}
          {dodDataAsOf && (
            <div
              style={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                gap: '20px',
                padding: '2px 0',
              }}
            >
              <span style={{ color: '#64748b', fontSize: '0.78rem' }}>DOD</span>
              <span style={{ fontWeight: 600, color: '#1e293b' }}>{dodDataAsOf}</span>
            </div>
          )}
          {/* Arrow pointing down toward the icon */}
          <div
            style={{
              position: 'absolute',
              top: '100%',
              left: '50%',
              transform: 'translateX(-50%)',
              width: 0,
              height: 0,
              borderLeft: '6px solid transparent',
              borderRight: '6px solid transparent',
              borderTop: '6px solid #e2e8f0',
            }}
          />
          <div
            style={{
              position: 'absolute',
              top: 'calc(100% - 1px)',
              left: '50%',
              transform: 'translateX(-50%)',
              width: 0,
              height: 0,
              borderLeft: '5px solid transparent',
              borderRight: '5px solid transparent',
              borderTop: '5px solid #ffffff',
            }}
          />
        </div>
      )}
    </span>
  );
};
